import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=2fc101e0&"
import script from "./sidebarItem.vue?vue&type=script&lang=js&"
export * from "./sidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc101e0')) {
      api.createRecord('2fc101e0', component.options)
    } else {
      api.reload('2fc101e0', component.options)
    }
    module.hot.accept("./sidebarItem.vue?vue&type=template&id=2fc101e0&", function () {
      api.rerender('2fc101e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/sidebar/sidebarItem.vue"
export default component.exports